import React from 'react';
import {ReactButton, ReactButtonProps} from '@gongxigames/framework/core/fragments/react';
import {MessagePopupButton} from '@gongxigames/framework/slot/types';

export type MessagePopupButtonComponentProps = Pick<ReactButtonProps, | 'disabled' | 'name' > & MessagePopupButton;
export type BaseButtonProps = Pick<ReactButtonProps, 'textVariables' | 'textId' | 'onClick'>;

const ButtonStyle: Partial<ReactButtonProps> = {
    borderThickness: 14,
    borderColor: 0xffffff,
    backgroundColor: 0x000000,
    round: 28,
    textStyleId: 'ErrorPopupButtonTitle',
    horizontalPadding: 160,
    verticalPadding: 18
};

export class MessagePopupButtonComponent extends React.Component<MessagePopupButtonComponentProps> {
    protected getBaseProps(button: MessagePopupButton): BaseButtonProps {
        if (typeof button.title === 'string') {
            return {
                textId: 'errorPopupTitleTemplate',
                textVariables: {title: button.title},
                onClick: button.action as () => void
            };
        }

        return {
            textId: button.title.id,
            onClick: button.action as () => void
        };
    }

    public render(): JSX.Element {
        const {
            title,
            action,
            ...otherProps
        } = this.props;
        const baseProps = this.getBaseProps({title, action});

        return <ReactButton {...baseProps} {...otherProps} {...ButtonStyle}/>;
    }
}
